import { render, staticRenderFns } from "./TestBankManager.vue?vue&type=template&id=2229fe50&scoped=true"
import script from "./TestBankManager.vue?vue&type=script&lang=js"
export * from "./TestBankManager.vue?vue&type=script&lang=js"
import style0 from "./TestBankManager.vue?vue&type=style&index=0&id=2229fe50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229fe50",
  null
  
)

export default component.exports